export const productFilters = [
  { name: "Brand", value: "brand" },
  { name: "Ram", value: "ram" },
  { name: "Storage", value: "storage" },
  { name: "Network", value: "network" },
  { name: "Price", value: "price" },
];
